<template>
    <div id="group-thread-summary-shat" v-if="!!selectedChat">
        <div class="head">
            <template>
                <a-dropdown :trigger="['click']">
                    <a class="ant-dropdown-link" @click.prevent>
                        <label class="imgUpload">
                            <a-avatar
                                id="team-summery-avatar"
                                v-if="
                                    groupProfilePicture || $_.get(selectedChat, 'meta.groupThread.groupProfilePicture')
                                "
                                :src="
                                    groupProfilePicture || $_.get(selectedChat, 'meta.groupThread.groupProfilePicture')
                                "
                                :size="84"
                            />
                            <div id="team-chat-container" v-else>
                                <TeamChatIcon id="team-chat-icon" />
                            </div>
                        </label>
                    </a>
                    <template #overlay>
                        <a-menu id="dropdown-menu">
                            <a-menu-item class="menu-item" key="0">
                                <input
                                    id="change-pp"
                                    style="display: none"
                                    type="file"
                                    @change="uploadFile"
                                    accept="image/png, image/jpeg, image/gif"
                                />
                                <label
                                    for="change-pp"
                                    v-if="
                                        groupProfilePicture ||
                                        $_.get(selectedChat, 'meta.groupThread.groupProfilePicture')
                                    "
                                    ><a>{{ $t("message.changePhoto") }}</a></label
                                >
                                <label for="change-pp" v-else
                                    ><a>{{ $t("message.addPhoto") }}</a></label
                                >
                            </a-menu-item>
                            <a-menu-item
                                class="menu-item"
                                key="1"
                                v-if="
                                    groupProfilePicture || $_.get(selectedChat, 'meta.groupThread.groupProfilePicture')
                                "
                            >
                                <a @click="showViewer">{{ $t("message.seePhoto") }}</a>
                            </a-menu-item>
                            <a-menu-divider
                                v-if="
                                    groupProfilePicture || $_.get(selectedChat, 'meta.groupThread.groupProfilePicture')
                                "
                            />
                            <a-menu-item
                                v-if="
                                    groupProfilePicture || $_.get(selectedChat, 'meta.groupThread.groupProfilePicture')
                                "
                                id="delete-option"
                                class="menu-item"
                                key="2"
                                @click="deleteProfilePhoto"
                                >{{ $t("message.deletePhoto") }}
                            </a-menu-item>
                        </a-menu>
                    </template>
                </a-dropdown>
            </template>
            <a-modal id="groupViewerModal" :visible="isImageViewerShow" :footer="false" @cancel="closeViewer">
                <img :src="groupProfilePicture || $_.get(selectedChat, 'meta.groupThread.groupProfilePicture')" />
            </a-modal>
        </div>
        <div class="user-name">{{ getName(selectedChat) }}</div>
        <MediaSlide v-if="mediaSlideVisible" @close-media-slide="mediaSlideVisible = false" />

        <div class="user-info" v-else>
            <div class="media-row" @click="mediaSlideVisible = true">
                <span class="media-text"> {{ $t("message.sumChat_MediaFile") }}</span>
                <span class="material-icons media-btn">arrow_forward</span>
            </div>
            <div class="add-new-user">
                <span class="user-info-head">{{ $t("message.userInformations") }}</span>
                <span class="new-user-icons" v-if="creator._id === user._id" @click="addUserListOpen">
                    <span class="material-icons" style="color: #ec4a1d">group_add</span>
                </span>
            </div>
            <div class="user-info-title">
                <span class="user-info-title-name">{{ $t("billing.Agents") }}</span>
            </div>
            <div v-for="agent in agents" style="margin-top: 5px">
                <div class="agent-item">
                    <span class="agent-item-info" @click="agent.userDetailVisible = !agent.userDetailVisible">
                        <div class="avatarContainer">
                            <!--                            <Avatar
                                :size="30"
                                :username="agent.name || ''"
                                :src="agent.gravatar || ''"
                                class="avatarClass"
                            />-->
                            <AgentAvatar :user-i-d="agent._id" :size="30" class="group-agents-avatar" />
                        </div>
                        <div class="nameContainer">
                            <div class="tooltip-container" :title="agent.name">
                                {{ agent.name }}
                            </div>
                        </div>
                    </span>

                    <a-popover
                        placement="bottom"
                        trigger="click"
                        overlayClassName="btnPopoverGroupMessage"
                        v-if="creator._id === user._id"
                    >
                        <span class="material-icons more_horiz"> more_horiz</span>
                        <template slot="content">
                            <div class="popover-item" @click="userLeaveGroup(agent)">
                                {{ $t("message.removeFromG") }}
                            </div>
                            <div class="popover-item" @click="directMessage(agent)">
                                {{ $t("message.sendMessage") }}
                            </div>
                        </template>
                    </a-popover>
                    <span class="material-icons dm-message-btn" @click="directMessage(agent)" v-else>message</span>
                </div>
                <div v-if="agent.userDetailVisible">
                    <div class="agent-item-detail" v-for="data in datas">
                        <span class="material-icons" id="agent-item-detail-icons">{{ data.icon }}</span>
                        <span class="poped_datas" :title="data.slot === 'email' ? agent[data.slot] : null">
                            {{ agent[data.slot] }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="user-info-title">
                <span class="user-info-title-name">{{ $t("message.chatCreator") }}</span>
            </div>
            <div class="creator-info" @click="creator.userDetailVisible = !creator.userDetailVisible">
                <span class="creator-info-item">
                    <div class="avatarContainer">
                        <!--                    <Avatar
                        :size="20"
                        :username="creator.name || ''"
                        class="sc-message&#45;&#45;avatar"
                    />-->
                        <AgentAvatar :user-i-d="creator._id" :size="30" class="group-agents-avatar" />
                    </div>
                    <div class="nameContainer">
                        <div class="tooltip-container" :title="creator.name">
                            {{ creator.name }}
                        </div>
                    </div>
                </span>
            </div>
            <div v-if="creator.userDetailVisible">
                <div class="agent-item-detail" v-for="data in datas">
                    <span
                        class="material-icons"
                        style="color: #e7957f; font-size: 15px; max-width: 22px; margin-right: 5px"
                        >{{ data.icon }}</span
                    >
                    <span class="poped_datas" :title="data.slot === 'email' ? creator[data.slot] : null">
                        {{ creator[data.slot] }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import MediaSlide from "./MediaSlide";
import CHAT_TYPES from "../../../utils/ChatTypes";
import Avatar from "vue-avatar";
import { sendSocketMessage } from "../../../utils/socketStream";
import { log2 } from "../../../utils/log2";
import { uploadAsset } from "../../../api/assetUpload";
import axios from "axios";
import TeamChatIcon from "../../../components/svg/TeamChatIcon.vue";
import AgentAvatar from "../../../components/common/AgentAvatar.vue";

const log = log2("GroupThreadSummaryChat");

export default {
    name: "GroupThreadSummaryChat",
    components: { TeamChatIcon, Avatar, MediaSlide, AgentAvatar },
    props: {},
    data() {
        return {
            datas: [
                {
                    name: "Email",
                    slot: "email",
                    icon: "email",
                },
                {
                    name: "Ülke, Dil",
                    slot: "lang",
                    icon: "language",
                },
                {
                    name: "Platform",
                    slot: "lastLoginPlatform",
                    icon: "settings_suggest",
                },
                {
                    name: "IP",
                    slot: "lastLoginIPAddress",
                    icon: "room",
                },
            ],
            agents: [],
            creator: [],
            mediaSlideVisible: false,
            groupProfilePicture: null,
            thread: [],
            isImageViewerShow: false,
        };
    },
    computed: {
        ...mapGetters({}),
        ...mapState({
            user: (state) => state.auth.user,
            selectedChat: (state) => state.team.selectedChat,
            site: (state) => state.site.site,
            chats: (state) => state.team.chats,
        }),
    },
    methods: {
        ...mapActions({
            selectedChatChange: "team/selectedChatChange",
            chatProfilePhotoUpdate: "team/chatProfilePhotoUpdate",
        }),
        showViewer() {
            this.isImageViewerShow = true;
        },
        closeViewer() {
            this.isImageViewerShow = false;
        },
        directMessage(user) {
            const isDmChat = this.chats.filter((chat) => {
                if (chat.meta.chatType === CHAT_TYPES.THREAD) {
                    if (chat.meta.thread.agent1._id === user._id || chat.meta.thread.agent2._id === user._id) {
                        return chat;
                    }
                }
            });
            if (isDmChat.length > 0) {
                this.selectedChatChange(isDmChat[0]);
            } else {
                const thread = {
                    agent1: this.user._id,
                    agent2: user._id,
                };

                sendSocketMessage("team thread-chat-created", {
                    siteId: this.site._id,
                    thread,
                });
            }
        },
        addUserListOpen() {
            const agentIds = this.selectedChat.meta.groupThread.agents.map((agent) => agent._id);
            this.$emit("add-user", { agentIds });
        },
        userLeaveGroup(agent) {
            sendSocketMessage("team leave-user-group", {
                siteId: this.site._id,
                chat: this.selectedChat,
                deleteUserId: agent._id,
                userId: this.user._id,
            });
            // this.agents = this.agents.filter((item) => item._id !== agent._id);
        },
        getName(data) {
            if (data.meta.chatType === "groupThread") {
                return data.meta.groupThread.title;
            } else if (data.meta.chatType === "thread") {
                if (data.meta.thread.agent2 === this.user.id) {
                    return data.meta.thread.agent1.name;
                }
                return data.meta.thread.agent2.name;
            } else if (data.meta.chatType === "department") {
                return data.meta.department.languageContent[0].name;
            } else {
                return data.meta.chatType;
            }
        },

        getSlot(slot) {
            if (slot === "name") {
                if (this.selectedChat.meta.chatType === CHAT_TYPES.THREAD) {
                    if (this.selectedChat.meta.thread.agent1.name === this.user.name) {
                        return this.selectedChat.meta.thread.agent2.name;
                    } else {
                        return this.selectedChat.meta.thread.agent1.name;
                    }
                }
            }
        },
        uploadFile: async function (e) {
            const file = e.target.files[0];

            if (this.beforeUploadPicture(file)) {
                const path = `${this.site._id}/groupProfilePicture`;

                try {
                    const uploadData = await uploadAsset({
                        path,
                        mime: file.type,
                        name: file.name,
                        size: file.size,
                        type: "team-chat",
                    });

                    const newGroupProfilePicture = uploadData.data.asset.v2Format && uploadData.data.asset.cdnUrl
                        ? uploadData.data.asset.cdnUrl
                        : `https://static.supsis.live/${path + uploadData.data.asset._id}`;
                    this.$store.dispatch("team/groupProfilePicture", {
                        chatId: this.selectedChat._id,
                        groupProfilePicture: newGroupProfilePicture,
                    });

                    await axios({
                        method: uploadData.data.method,
                        url: uploadData.data.url,
                        data: file,
                        headers: { "Content-Type": "application/octet-stream" },
                    });

                    this.$toasted.success(this.$t("message.successImgUpload"), {
                        duration: 1000,
                        position: "bottom-center",
                    });

                    this.groupProfilePicture = newGroupProfilePicture;
                    this.chatProfilePhotoUpdate({
                        chatId: this.selectedChat._id,
                        groupProfilePicture: newGroupProfilePicture,
                    });
                } catch (e) {
                    this.$toasted.error(this.$t("message.errorImgUpload"), {
                        duration: 1000,
                        position: "bottom-center",
                    });
                }
            }
        },
        deleteProfilePhoto() {
            this.$dialog
                .confirm(this.$t("message.deletePhoto"), {
                    okText: this.$t("message.continue"),
                    cancelText: this.$t("message.cancel"),
                })
                .then(() => {
                    try {
                        this.$store.dispatch("team/groupProfilePicture", {
                            chatId: this.selectedChat._id,
                            groupProfilePicture: null,
                        });
                        this.$toasted.success(this.$t("message.successImgDelete"), {
                            duration: 1000,
                            position: "bottom-center",
                        });
                        this.groupProfilePicture = null;
                        this.chatProfilePhotoDelete({
                            chatId: this.selectedChat._id,
                            groupProfilePicture: null,
                        });
                    } catch (e) {
                        this.$toasted.error(this.$t("message.errorImgDelete"), {
                            duration: 1000,
                            position: "bottom-center",
                        });
                    }
                });
        },
        beforeUploadPicture(file) {
            const isJPG = file.type === "image/jpeg";
            const isPNG = file.type === "image/png";
            const isGIF = file.type === "image/gif";
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG && !isPNG && !isGIF) {
                this.$toasted.error(this.$t("message.errorImgUpload"), {
                    duration: 1000,
                    position: "bottom-center",
                });
                return false;
            }
            if (!isLt2M) {
                this.$toasted.error(this.$t("message.errorImgUpload"), {
                    duration: 1000,
                    position: "bottom-center",
                });
                return false;
            }
            return true;
        },
    },

    mounted() {
        if (this.selectedChat) {
            this.agents = this.selectedChat.meta.groupThread.agents;
            this.agents = this.agents.map((agent) => {
                return {
                    ...agent,
                    userDetailVisible: false,
                };
            });
            this.creator = this.selectedChat.meta.groupThread.creator;
            this.creator = {
                ...this.creator,
                userDetailVisible: false,
            };
        }
    },

    watch: {
        selectedChat(newVal) {
            this.agents = newVal.meta.groupThread.agents;
            this.agents = this.agents.map((agent) => {
                return {
                    ...agent,
                    userDetailVisible: false,
                };
            });
            this.creator = newVal.meta.groupThread.creator;
            this.creator = {
                ...this.creator,
                userDetailVisible: false,
            };
        },
    },
};
</script>

<style lang="scss">
.btnPopoverGroupMessage {
    margin-right: 20px;

    .ant-popover-inner-content {
        padding: 0 !important;
    }

    .popover-item {
        border: none;
        cursor: pointer;
        padding: 5px;

        &:hover {
            background-color: #ebebeb;
        }
    }
}

#group-thread-summary-shat {
    .tooltip-container {
        width: 105px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .head {
        display: flex;
        justify-content: center;
        padding: 10px;
        align-items: end;

        .user-segment-avatar {
            height: 55px;
            width: 55px;
            display: flex;
            align-items: center;
            font-size: 16px;
            background: #c4c4c4;
            border-radius: 50%;
            margin: 5px;
        }

        .user-active {
            height: 10px;
            width: 10px;
            background: green;
            border-radius: 50%;
            margin-bottom: 10px;
            margin-left: -16px;
        }
    }

    .more_horiz {
        color: #9c9c9c;
        font-size: 20px;
        cursor: pointer;
        margin-right: 25px;
    }

    .user-name {
        font-size: initial;
        font-weight: 600;
        display: flex;
        justify-content: center;
    }

    .less-more {
        color: #ec4a1d;
        font-size: 20px;
        max-width: 22px;
    }

    .user-type {
        font-size: initial;
        font-weight: 200;
        display: flex;
        justify-content: center;
    }

    .user-info {
        margin-top: 30px;
        margin-left: 20px;

        .media-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;
            cursor: pointer;

            .media-text {
                font-size: 17px;
                font-weight: 600;
                color: #9f8524;
            }

            .media-btn {
                color: #9f8524;
                font-size: 17px;
                max-width: 22px;
                margin-right: 35px;
                font-weight: 600;
            }
        }

        .add-new-user {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .new-user-icons {
                margin-right: 30px;
                display: flex;
                align-items: center;
                cursor: pointer;
            }
        }

        .agent-item {
            display: flex;
            align-items: center;
            margin-top: 5px;
            justify-content: space-between;

            .agent-item-info {
                display: flex;
                align-items: center;
                width: 100%;
                padding: 3px;
                cursor: pointer;
                border-radius: 7px;

                &:hover {
                    background: #ebebeb;
                }

                .avatarContainer {
                    width: 25%;
                }

                .nameContainer {
                    width: 45%;
                    font-weight: 600;
                }
            }

            .dm-message-btn {
                font-size: 20px;
                margin-right: 35px;
                cursor: pointer;
            }
        }

        .user-info-head {
            font-weight: 600;
            font-size: medium;
        }

        .user-info-title {
            display: flex;
            align-items: center;
            margin-top: 15px;

            .user-info-title-name {
                padding-left: 5px;
                font-size: large;
                font-style: italic;
            }
        }

        .creator-info {
            display: flex;
            align-items: center;
            margin-top: 5px;
            justify-content: space-between;

            .creator-info-item {
                display: flex;
                align-items: center;
                padding: 3px;
                cursor: pointer;
                border-radius: 7px;
                width: 85%;

                &:hover {
                    background: #ebebeb;
                }

                .avatarContainer {
                    width: 30%;

                    .sc-message--avatar {
                        color: white;
                        font-size: 15px;
                    }
                }

                .nameContainer {
                    width: 45%;
                    font-weight: 600;
                }
            }
        }

        .agent-item-detail {
            margin-left: 20px;
            margin-top: 5px;
            display: flex;
            align-items: center;

            #agent-item-detail-icons {
                color: #e7957f;
                font-size: 15px;
                max-width: 22px;
                margin-right: 5px;
            }
        }

        .poped_datas {
            width: 150px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    &::-webkit-scrollbar {
        display: none !important;
    }
}

.imgUpload {
    cursor: pointer;
    position: relative;
    width: 84px;
    height: 84px;

    &:hover {
        .imgUploadOver {
            opacity: 1;
        }
    }

    .imgUploadOver {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 2;
        background-color: rgba(0, 0, 0, 0.55);
        color: #ffffff;
        font-size: 32px;
        opacity: 0;
        transition: all 0.3s ease-in-out;
        cursor: pointer;
        border-radius: 100%;
        text-align: center;
        line-height: 64px;
        display: grid;
        place-items: center;
    }
}

#groupViewerModal {
    .ant-modal-content {
        width: max-content;
        margin: auto;

        .ant-modal-body {
            height: 512px !important;
            width: max-content !important;
        }
    }
}

.group-agents-avatar {
    position: relative;
    width: 30px;
    height: 30px;
    font-size: 14px !important;

    #avatar-img {
        border-radius: 50%;
        height: 30px !important;
        width: 30px !important;
        object-fit: cover;
    }

    #avatar-placeholder {
        border-radius: 50%;
        height: 30px !important;
        width: 30px !important;
        object-fit: cover;
        display: grid;
        place-items: center;

        span {
            font-size: 14px !important;
        }
    }

    #offline-dot {
        position: absolute;
        height: 25% !important;
        width: 25% !important;
        border-radius: 50%;
        background-color: #aeaeae;
        border: 0.5px solid white;
    }

    #online-dot {
        position: absolute;
        height: 25% !important;
        width: 25% !important;
        border-radius: 50%;
        background-color: #009900;
        border: 0.5px solid white;
    }
}
</style>
<style lang="scss" scoped>
#team-chat-container {
    width: 85px;
    height: 85px;
    background-color: #d3d3d3;
    border-radius: 50%;
    display: grid;
    place-items: center;
}
</style>
